import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const FilterSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <div
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg height="100px" width="100px" fill={color} xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 48 48" x="0px" y="0px">
        <title>Icon-set-line</title>
        <path d="M16.05,32.65a5.14,5.14,0,0,0-3.74-4.94V7.4a1.4,1.4,0,1,0-2.8,0V27.71a5.13,5.13,0,0,0,0,9.88v3a1.4,1.4,0,0,0,2.8,0v-3A5.14,5.14,0,0,0,16.05,32.65ZM10.91,35a2.34,2.34,0,1,1,2.34-2.34A2.34,2.34,0,0,1,10.91,35Z" />
        <path d="M42.23,32.65a5.14,5.14,0,0,0-3.74-4.94V7.4a1.4,1.4,0,1,0-2.8,0V27.71a5.13,5.13,0,0,0,0,9.88v3a1.4,1.4,0,1,0,2.8,0v-3A5.14,5.14,0,0,0,42.23,32.65ZM37.09,35a2.34,2.34,0,1,1,2.34-2.34A2.34,2.34,0,0,1,37.09,35Z" />
        <path d="M18.86,15.35a5.14,5.14,0,0,0,3.74,4.94V40.6a1.4,1.4,0,0,0,2.8,0V20.29a5.13,5.13,0,0,0,0-9.88v-3a1.4,1.4,0,1,0-2.8,0v3A5.14,5.14,0,0,0,18.86,15.35ZM24,13a2.34,2.34,0,1,1-2.34,2.34A2.34,2.34,0,0,1,24,13Z" />
      </svg>
    </div>
  );
};

FilterSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default FilterSVG;
